import React from 'react';
import {
  CYBERSOURCE_PSP_ID,
  HIPAY_PSP_ID,
  IXOPAY_PSP_ID,
} from 'Components/widgets/payment-info/PaymentInfo.const';
import { CyberSourceForm } from './CybersourceForm';
import { HipayForm } from './HipayForm';
import { IxopayCardForm } from './IxopayCardForm';

type PaymentProviderFormProps = {
  selectedPaymentProvider: PaymentProvider;
};

export const PaymentProviderForm = ({ selectedPaymentProvider }: PaymentProviderFormProps) => {
  return (
    <div className="mt-20" id="payment-form-iframe">
      {selectedPaymentProvider.id === HIPAY_PSP_ID && <HipayForm />}
      {selectedPaymentProvider.id === CYBERSOURCE_PSP_ID && (
        // -expect-error TODO(flow-migration): CyberSource provider always has a token
        <CyberSourceForm token={selectedPaymentProvider.token.value} />
      )}
      {selectedPaymentProvider.id === IXOPAY_PSP_ID && <IxopayCardForm />}
    </div>
  );
};
